
import request from '@/utils/request'

export function getListProductAttributeApi(query) {
  return request({
    url: '/config-service/v1/product-attribute',
    method: 'get',
    params: query
  })
}

export function addProductAttributeApi(query) {
  return request({
    url: '/config-service/v1/product-attribute',
    method: 'post',
    data: query
  })
}

export function updateProductAttributeApi(query) {
  return request({
    url: `/config-service/v1/product-attribute/${query.id}`,
    method: 'put',
    data: query
  })
}

export function deleteProductAttributeApi(query) {
  return request({
    url: '/config-service/v1/product-attribute',
    method: 'delete',
    data: query
  })
}
